import { fetchWithAuth } from './authFetch'

const API_BASE_URL = `${process.env.VUE_APP_API_BASE_URL}/matches`;

// Cache para requests em andamento (evita duplicação)
const activeRequests = new Map();

async function fetchFromApi(endpoint, options = {}) {
  const url = `${API_BASE_URL}${endpoint}`;

  // Verificar se já existe um request ativo para este endpoint
  if (activeRequests.has(endpoint)) {
    console.log(`Request já ativo para ${endpoint}, aguardando...`);
    return activeRequests.get(endpoint);
  }

  const defaultHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Token ${localStorage.getItem('userToken')}`
  };

  // Adicionar timeout padrão de 30 segundos se não especificado
  const timeoutMs = options.timeout || 30000;
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeoutMs);

  const config = {
    ...options,
    signal: controller.signal,
    headers: {
      ...defaultHeaders,
      ...options.headers
    }
  };

  // Criar promise e armazenar no cache
  const requestPromise = (async () => {
    try {
      console.log(`Iniciando request para ${endpoint}`);
      const startTime = performance.now();

      const response = await fetchWithAuth(url, config);

      const endTime = performance.now();
      console.log(`Request ${endpoint} completado em ${(endTime - startTime).toFixed(0)}ms`);

      clearTimeout(timeoutId);

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Erro desconhecido');
      }

      // If the response status is 204 (No Content), return null
      if (response.status === 204) {
        return null;
      }

      return await response.json();
    } catch (error) {
      clearTimeout(timeoutId);

      if (error.name === 'AbortError') {
        console.warn(`Request ${endpoint} cancelado por timeout (${timeoutMs}ms)`);
        throw new Error('Request timeout - API demorou muito para responder');
      }

      console.error(`Erro ao fazer requisição para ${endpoint}:`, error);
      throw error;
    } finally {
      // Remover do cache após completar (sucesso ou erro)
      activeRequests.delete(endpoint);
    }
  })();

  // Armazenar no cache
  activeRequests.set(endpoint, requestPromise);

  return requestPromise;
}

export function fetchMatches(page = 1, searchTerm = '') {
  return fetchFromApi(`/?page=${page}&search=${encodeURIComponent(searchTerm)}`);
}

export function fetchDraws(page = 1, searchTerm = '') {
  return fetchFromApi(`/draws/?page=${page}&search=${encodeURIComponent(searchTerm)}`);
}

export function fetchDale(botId, page = 1, searchTerm = '') {
  return fetchFromApi(`/dale/${botId}/?page=${page}&search=${encodeURIComponent(searchTerm)}`);
}

export function fetchLastDays(botId) {
  return fetchFromApi(`/last-days/?id=${botId}`);
}

export function fetchLiveMatches() {
  return fetchFromApi('/live/');
}

export function fetchNextMatches() {
  return fetchFromApi('/next/');
}
